/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Fmt_TitleInputs */

const en_pc_online_fmt_title = /** @type {(inputs: Pc_Online_Fmt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported formats`)
};

const zh_pc_online_fmt_title = /** @type {(inputs: Pc_Online_Fmt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持的格式`)
};

/**
* | output |
* | --- |
* | "Supported formats" |
*
* @param {Pc_Online_Fmt_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_fmt_title = /** @type {((inputs?: Pc_Online_Fmt_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Fmt_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_fmt_title(inputs)
	return zh_pc_online_fmt_title(inputs)
});
export { pc_online_fmt_title as "pc.online.fmt_title" }